import { render, staticRenderFns } from "./BusinessOrderInfo.vue?vue&type=template&id=48ba80e8"
import script from "./BusinessOrderInfo.vue?vue&type=script&lang=js"
export * from "./BusinessOrderInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports